import axios from "axios";

export function addView() {
	const addViewElement = document.getElementById('add-view');

	if (addViewElement) {
		const dataLink = addViewElement.dataset.link;

		axios.put(dataLink);
	}
}
